var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#edit-cartIcon_svg__filter0_d_1_8463)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 46,
    r: 36,
    fill: "#282828"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 41.906c-.43 0-.844.162-1.149.449a1.488 1.488 0 00-.476 1.083c0 .406.171.795.476 1.082.305.287.718.449 1.149.449h1.625c0 .406.171.795.476 1.082.305.288.718.449 1.149.449.43 0 .844-.161 1.149-.449.305-.287.476-.676.476-1.082.862 0 1.688-.323 2.298-.897.61-.575.952-1.354.952-2.166v-1.531c0-.812-.342-1.591-.952-2.166a3.354 3.354 0 00-2.298-.897h-3.25v-1.53h4.875c.43 0 .844-.162 1.149-.45.305-.286.476-.676.476-1.082s-.171-.796-.476-1.083a1.677 1.677 0 00-1.149-.448h-1.625c0-.406-.171-.796-.476-1.083A1.677 1.677 0 0052 31.188c-.43 0-.844.16-1.149.448a1.488 1.488 0 00-.476 1.083c-.862 0-1.688.322-2.298.897a2.976 2.976 0 00-.952 2.165v1.532c0 .812.342 1.59.952 2.165.61.574 1.436.897 2.298.897h3.25v1.531H48.75z",
    fill: "#EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25.063H39a5.03 5.03 0 00-3.447 1.345c-.914.861-1.428 2.03-1.428 3.248v36.75c0 .256.07.508.2.733.13.225.319.415.547.553a1.712 1.712 0 001.625.107L39 66.714l2.584 1.087a1.708 1.708 0 001.332 0l2.584-1.087 2.584 1.087a1.708 1.708 0 001.332 0L52 66.713l2.584 1.087a1.708 1.708 0 001.332 0l2.584-1.087 2.584 1.087a1.708 1.708 0 001.332 0L65 66.713l2.584 1.087a1.698 1.698 0 001.544-.107c.228-.139.417-.33.547-.554.13-.224.2-.477.2-.733v-36.75c0-1.218-.514-2.386-1.428-3.248A5.03 5.03 0 0065 25.062zm1.625 38.97l-.959-.398a1.708 1.708 0 00-1.332 0l-2.584 1.087-2.584-1.087a1.708 1.708 0 00-1.332 0l-2.584 1.087-2.584-1.087a1.708 1.708 0 00-1.332 0l-2.584 1.087-2.584-1.087a1.708 1.708 0 00-1.332 0l-2.584 1.087-2.584-1.087a1.708 1.708 0 00-1.332 0l-.959.398V29.656c0-.406.171-.795.476-1.082A1.677 1.677 0 0139 28.124h26c.43 0 .844.161 1.149.448.305.288.476.677.476 1.083v34.377z",
    fill: "#EEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.125 49.563h-16.25c-.43 0-.844.16-1.149.448a1.488 1.488 0 00-.476 1.083c0 .406.171.795.476 1.082.305.288.718.449 1.149.449h16.25c.43 0 .844-.161 1.149-.449.305-.287.476-.676.476-1.082s-.171-.796-.476-1.083a1.677 1.677 0 00-1.149-.449zM60.125 55.688h-16.25c-.43 0-.844.16-1.149.448a1.488 1.488 0 00-.476 1.083c0 .406.171.795.476 1.082.305.288.718.449 1.149.449h16.25c.43 0 .844-.161 1.149-.449.305-.287.476-.676.476-1.082s-.171-.796-.476-1.083a1.677 1.677 0 00-1.149-.449z",
    fill: "#EEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "edit-cartIcon_svg__filter0_d_1_8463",
    x: 0.348,
    y: 0.609,
    width: 103.304,
    height: 103.304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.826
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_8463"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_8463",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/media/edit-cartIcon.11d11f9a.svg";
export { SvgEditCartIcon as ReactComponent };